const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://4js5ls43lf.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://1jbsklwpcd.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: ' bugfix/CV4-3138-hotfix-teams-self-referencing-parents-children',
    HOSTNAME: 'https://teams-service.dev.apps.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.apps.forwoodsafety.com',
    WEBSOCKET: 'wss://w7wfrjk2l6.execute-api.us-west-2.amazonaws.com/dev'
  },
};

export default config;
